<template>
    <section class="featured-products home-page__block carousel-outer-wrap" v-if="featuredProducts.length > 0">
        <h3>{{ lang('fooldal_kiemelt_termekek_cim')}}</h3>     
        <div class="featured-products__carousel carousel-wrap" v-if="dataIsReady">            
            
            <carousel :initialize="timer()" :items="4" :margin="30" :autoWidth="true" :dots="false"  :loop="false" :responsive="{ 
                            0:{
                                items:1,
                                autoWidth: true,
                                margin: 10,
                                mouseDrag: true,                                 
                                nav: false},      
                            576:{items:3, mouseDrag:true, nav:false, margin: 20},
                            768:{items:3, mouseDrag:true, margin: 20},                            
                            992:{items:3, mouseDrag:false},
                            1200:{items:4, mouseDrag:false}                            
                }">                                    
                    
                    <ProductItem v-for="fProduct in featuredProducts" 
                        :key="fProduct.id" 
                        :name="fProduct.name"                         
                        :product_slug="fProduct.slug" 
                        :srcset="itemSrcset(fProduct)" :src="itemSrc(fProduct, 'w286h440')" 
                        :id="fProduct.id"
                     />                        
            </carousel>        
        </div>   
        <div class="carousel-block-btn-wrap">
            <router-link :to="{name: 'Products_'+ currentLangName()}" class="btn btn--primary"><span>{{ lang("osszes_termek_megtekintese_btn_text")}}</span></router-link>
        </div>
    </section>
</template>

<script>
import axios from 'axios'
import carousel from 'vue-owl-carousel'
import ProductItem from '@/components/pagesComponents/products/ProductItem.vue'

export default {
    components:{
        ProductItem,
        carousel
    },    
    data(){
        return{
            featuredProducts: [],
            dataIsReady: false
        }
    },   
    created(){        
        this.getProducstFeaturedProducts()
    },
    methods:{
        timer(){
            var start = new Date().getTime();
            while (new Date().getTime() < start + 500);            
        },
        getProducstFeaturedProducts(){
            let _this = this

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/filter/1?relations=1&relations_params[information][where][0][0]=where&relations_params[information][where][0][1]=status&relations_params[information][where][0][2]=1&relations_params[information][order_by][0][0]=sort_order&relations_params[information][order_by][0][1]=asc&relations_params[information][order_by][1][0]=name&relations_params[information][order_by][1][1]=asc',{
                params:{
                    "language_id": _this.$store.getters.getSelectedLang.id     
                }
            }).then(response => {                       
                if (response.data.status === true){
                    _this.featuredProducts = []
                    var array = response.data.filter[0].information;
                    for (var i = array.length - 1; i > 0; i--) {
                        var j = Math.floor(Math.random() * (i + 1));
                        var temp = array[i];
                        array[i] = array[j];
                        array[j] = temp;
                    }
                    for ( i = 0; i < 4 && i < array.length; i++)
                    {
                        _this.featuredProducts.push(array[i]); 
                    }
                    _this.dataIsReady = true   
                } else {
                        _this.dataIsReady = false
                        _this.featuredProducts = []
                }                        
            }).catch((err) => {
                console.log(err)
            });
        }
    }       
}
</script>